import {
  BaseQueryFn,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react"
import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions"
import {
  dynamicMiddlewaresInstance,
  registerReducer,
  RootState,
} from "@/core/store"
import { baseQueryWithReauth } from "@/modules/app/store"
import { GetMailingCredentialsRes } from "../../interface/interface"

const tagTypes = ["MailingCredentials"] as const
const reducerPath: string = "postBotMailingApi"

const baseTGStatApiURL = new URL(
  import.meta.env.REACT_APP_POSTBOT_API,
  window.location.origin,
).toString()

const baseQuery: BaseQueryFn = fetchBaseQuery({
  baseUrl: `${
    baseTGStatApiURL.endsWith("/") ? baseTGStatApiURL : baseTGStatApiURL + "/"
  }`,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token
    if (token) {
      headers.set("authorization", `Bearer ${token}`)
    }
    return headers
  },
})

type ApiEndpointBuilder = EndpointBuilder<
  typeof baseQuery,
  (typeof tagTypes)[number],
  typeof reducerPath
>

const endpoints = (build: ApiEndpointBuilder) => ({
  getMailingCredentials: build.query<GetMailingCredentialsRes, void>({
    query: () => ({
      url: `mailing/credentials`,
      method: "GET",
    }),
  }),
})

export const postBotMailingApi = createApi({
  reducerPath,
  tagTypes,
  baseQuery: baseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    ...endpoints(build),
  }),
})
dynamicMiddlewaresInstance.addMiddleware(postBotMailingApi.middleware)
registerReducer(postBotMailingApi.reducerPath, postBotMailingApi.reducer)

export const { useLazyGetMailingCredentialsQuery } = postBotMailingApi
